export default __webpack_public_path__ + "static/media/design.6ed8f636.svg";